import { jsx as _jsx } from "react/jsx-runtime";
import { useBlockProps } from '@wordpress/block-editor';
import { RawHTML } from '@wordpress/element';
export default function FormSaveBlock({ attributes }) {
    const { portalId, formId } = attributes;
    if (portalId && formId) {
        return (_jsx(RawHTML, { ...useBlockProps.save(), children: `[hubspot portal="${portalId}" id="${formId}" type="form"]` }));
    }
    return null;
}
